{
  "date": "{{day}} {{month}}, {{year}}",
  "header": "Congratulations, {{firstName}}! The agent is currently processing your transaction.",
  "noDownPayment": {
    "last4": "<p>You may see a $0 charge on your account ending in <strong>{{last4}}</strong> for authentication purposes.</p>",
    "noLast4": "<p>You may see a $0 charge on your account for authentication purposes.</p>"
  },
  "downPayment": {
    "last4": "<p>We will debit <strong><downPayment /></strong> from your account ending in <strong>{{last4}}</strong> today.</p>",
    "noLast4": "<p>We will debit <strong><downPayment /></strong> from your account today.</p>"
  },
  "uplift": {
    "payLink": "https://pay.uplift.com",
    "starting-next-month": "<p>Your first monthly payment of <bold><monthlyPayment /></bold> will be due on <strong><dueDate /></strong>. Don't worry, Uplift will notify you before each payment is due.</p>",
    "manage-loan": "<p>You can always manage your loan, view upcoming payments, or ask us any questions at <0>pay.uplift.com</0>. Just log in using your phone number!</p>",
    "thank-you": "<p>Thanks for using Uplift!</p>"
  },
  "flexpay": {
    "payLink": "https://upgrade.com/pay",
    "starting-next-month": "<p>Your first monthly payment of <monthlyPaymentAuto><monthlyPayment /></monthlyPaymentAuto> will be due on <firstPaymentDateAuto><dueDate /></firstPaymentDateAuto>. Don't worry, Flex Pay will notify you before each payment is due.</p>",
    "manage-loan": "<p>You can always manage your loan, view upcoming payments, or ask us any questions at <0>upgrade.com/pay</0>. Just log in using your phone number!</p>",
    "thank-you": "<p>Thanks for using Flex Pay!</p>"
  }
}
